export default {
      id: "tax-savings-1-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#tax-savings-1",
      toString: function () {
        return this.url;
      }
    }